import Resource from './Resource';

export default class ExternalFilePicker extends Resource {
	constructor(options={}) {
		let {
			query = {}
		} = options;

		let config = {
			route: '/file-picker-apis',
			query: query,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
